import React, { useEffect, useRef } from 'react';
import { createPopper } from '@popperjs/core';
import { gsap } from 'gsap';
import './Hero.scss';
import logoImg from '../../assets/logo.png';
import videoLoopD from '../../assets/heroD.mp4';
import videoLoopM from '../../assets/heroM.mp4';

function Hero() {
  const logoTooltip = useRef();
  const videoLoopRef = useRef();

  useEffect(() => {
    gsap.to('#logo', { opacity: 1, y: 0, duration: 0.7, delay: 0.5 });
    gsap.to('#title', { opacity: 1, y: 0, duration: 0.7, delay: 0.8 });

    videoLoopRef.current.play();
  }, []);

  const handleMouseEnterLogo = (e) => {
    const content = logoTooltip.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  const handleMouseLeaveLogo = () => {
    logoTooltip.current.style.visibility = 'hidden';
  };

  return (
    <section className="hero">
      <div className="video-loop-container">
        <video autoPlay muted playsInline loop className="video-loop" ref={videoLoopRef}>
          <source media="(min-width:481px)" src={videoLoopD} type="video/mp4" />
          <source media="(max-width:480px)" src={videoLoopM} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="hero__titleBox">
        <div className="logo__container" id="logo">
          <p className="logo-copy">Content By</p>
          <a
            href="https://www.realtor.com/thats-who-we-r/"
            target="_blank"
            rel="sponsored noopener"
            className="nar"
          >
            <img
              className="logo"
              src={logoImg}
              alt="NAR logo"
              onMouseEnter={(e) => {
                handleMouseEnterLogo(e);
              }}
              onMouseLeave={handleMouseLeaveLogo}
            />
          </a>
          <div className="tooltip" ref={logoTooltip}>
            <p className="tooltip-content">Visit www.realtor.com/thats-who-we-r/</p>
          </div>
        </div>
        <h1 className="hero__titleBox-title" id="title">
          Pathways to Ownership
          <br />
          <span className="hero__titleBox-subtitle">
            In the midst of rising interest rates and low housing inventory, first-time buyers get
            creative to get into their first home.
          </span>
        </h1>
      </div>
    </section>
  );
}

export default Hero;
